import { useEffect, useState } from 'react';
import { Route, Routes, useLocation,Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Profile from '../pages/profile/Profile';
import Login from "@pages/Login";
import DeleteAccount from "@pages/DeleteAccount";
import ForgotPassword from '@pages/ForgotPassword';
import Register from '@pages/Register';
import RegisterMobile from '@pages/RegisterMobile';
import CreateApplication from "@pages/insurance";
import CreateTravelApplication from "@pages/travel";
import LeadList from '@pages/insurance/list/InsuranceList';
import TravelList from '@pages/travel/list/TravelList';
import Header from "@common/Header";
import PrivateRoute from '@src/routes/privateRoute';
import ClaimList from '@pages/claims/list/ClaimList';
import PaymentAddEdit from "@pages/payment/PaymentAddEdit";
import QuoteDetails from "@pages/QuoteDetails";
import NotFound from '@src/common/NotFound';
import { getPublicKey } from '@src/store/slices/encryption';
import mappingAgencyList from "../pages/mappingAgency/mappingAgencyList"
import { isMobile } from 'react-device-detect';


export default function AppRoutes() {
    const location = useLocation()
    let currentPath = location.pathname;

    const [loadRoutes, setLoadRoutes] = useState(true)

    useEffect(()=>{

        getPublicKey().then((res: any)=> {
            if(res?.data) setLoadRoutes(true)
        })

    },[])

    return (
        <>
            {
                !["/", "", "/login", "/register","/not-found","/forgot-password","/delete/account", "/not-found", "/readOcrDocument"].includes(currentPath) && <Header />
            }
            {
                loadRoutes && <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/register" element={isMobile ? <RegisterMobile /> : <Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/delete/account" element={<DeleteAccount />} />
                    <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />          
                    <Route path="/my-profile" element={<PrivateRoute component={Profile} />} />
                    <Route path="/create-insurance-policy" element={<PrivateRoute component={CreateApplication} />} />
                    <Route path="/create-insurance-policy/:id" element={<PrivateRoute component={CreateApplication} />} />
                    <Route path="/create-travel-insurance" element={<PrivateRoute component={CreateTravelApplication} />} />
                    <Route path="/create-travel-insurance/:id" element={<PrivateRoute component={CreateTravelApplication} />} />
                    <Route path="/insurance-list" element={<PrivateRoute component={LeadList} />} />
                    <Route path="/travel-list" element={<PrivateRoute component={TravelList} />} />
                    <Route path="/claim-list" element={<PrivateRoute component={ClaimList} />} />

                    <Route path="/payment-add/:id" element={<PrivateRoute component={PaymentAddEdit} />} />
                    <Route path="/quote-details/:id" element={<PrivateRoute component={QuoteDetails} />} />
                   <Route path="/mapping-agency-list" element={<PrivateRoute component={mappingAgencyList} />} />
                    <Route path="*" element={<Navigate to="/not-found"/>} />
                    <Route path="/not-found" element={<NotFound/>} /> 
                </Routes>
            }

        </>
    )
}
